export default "__VITE_ASSET__887c764e__"